import { cn } from "@/lib/cn"

type StepperCurrent = "upload" | "preview" | "review"

const LABELS = ["Upload", "Preview", "Review"] as const
const STEP_IDX: Record<StepperCurrent, number> = { upload: 0, preview: 1, review: 2 }

export function VaultStepper({ current }: { current: StepperCurrent }) {
  const idx = STEP_IDX[current]

  return (
    <div className="px-6 pt-5 pb-1">
      <div className="flex items-center gap-2">
        {[0, 1, 2].map((i) => (
          <div
            key={i}
            className={cn(
              "relative h-[3px] flex-1 overflow-hidden rounded-full",
              i < idx ? "bg-accent-amber" : "bg-border-default",
            )}
          >
            {i === idx && (
              <div
                className="absolute inset-0 rounded-full"
                style={{
                  background: "var(--accent-amber)",
                }}
              />
            )}
          </div>
        ))}
      </div>
      <div className="mt-2 flex justify-between">
        {LABELS.map((label, i) => (
          <span
            key={label}
            className={cn(
              "font-mono text-[10px] uppercase tracking-widest",
              i === idx ? "text-accent-amber" : i < idx ? "text-text-secondary" : "text-text-muted",
            )}
          >
            {label}
          </span>
        ))}
      </div>
    </div>
  )
}
